module.exports = __webpack_public_path__ + "static/media/lauren-cohen-lose.08bed13a.jpg";